(() => {
  if (customElements.get('bc-service-engine')) return;
  class ServiceEngine extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (node, type, callback, options={}) => node.addEventListener(type, callback, {...options,signal:this.abort.signal});
      this.network = this.querySelector('[data-engine-network]');
      this.hub = this.querySelector('[data-engine-hub]');
      this.art = this.querySelector('[data-engine-symbol-art]');
      this.wires = this.querySelector('[data-engine-wires]');
      this.chargeRing = this.querySelector('[data-engine-charge]');
      this.chargeLevel = 0; this.chargeCompletedAt = null; this.completionPlayed = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width:749px)');
      const ns = 'http://www.w3.org/2000/svg';
      const definitions = document.createElementNS(ns, 'defs'); this.wires.append(definitions);
      const gradientPrefix = 'bc-service-trail-' + this.querySelector('.bc-service-engine__heading').id;
      const packets = document.createElementNS(ns, 'g');
      this.connections = [...this.querySelectorAll('[data-engine-card]')].map((card, index) => {
        const group = document.createElementNS(ns, 'g');
        group.setAttribute('class', 'bc-service-engine__connection'+(card.hasAttribute('aria-current') ? ' is-current' : ''));
        const line = document.createElementNS(ns, 'path'); line.setAttribute('class','bc-service-engine__wire');
        const trail = document.createElementNS(ns, 'path'); trail.setAttribute('class', 'bc-service-engine__trail'); trail.setAttribute('pathLength', '1');
        const gradient = document.createElementNS(ns, 'linearGradient');
        gradient.setAttribute('id', `${gradientPrefix}-${index}`); gradient.setAttribute('gradientUnits', 'userSpaceOnUse');
        [[0,0],[.45,.2],[1,1]].forEach(([offset,opacity]) => {
          const stop = document.createElementNS(ns, 'stop'); stop.setAttribute('class','bc-service-engine__trail-stop');
          stop.setAttribute('offset',String(offset)); stop.setAttribute('stop-opacity',String(opacity)); gradient.append(stop);
        });
        definitions.append(gradient); trail.setAttribute('stroke',`url(#${gradientPrefix}-${index})`);
        const dot = document.createElementNS(ns,'circle'); dot.setAttribute('class','bc-service-engine__dot');dot.setAttribute('r','2');
        group.append(line,trail);this.wires.append(group);packets.append(dot);
        const play = active => {
          group.classList.toggle('is-selected',active);
          this.icon(card,active);
        };
        on(card,'pointerenter',event => {if(event.pointerType==='mouse')play(true);});
        on(card,'pointerleave',() => play(false));on(card,'focus',() => play(true));on(card,'blur',() => play(false));
        on(card.querySelector('[data-engine-icon]'),'ready',() => this.icon(card));
        return {card,line,trail,gradient,dot,index,delay:index*550,arrivalCycle:-1};
      });
      this.wires.append(packets);
      this.connections.forEach(({card})=>this.icon(card));
      if (!customElements.get('lord-icon') && !document.querySelector('script[data-bc-lordicon-player]')) {
        const loader=document.createElement('script');loader.src=this.dataset.iconPlayer;loader.async=true;loader.dataset.bcLordiconPlayer='';document.head.append(loader);
      }
      this.resize=new ResizeObserver(()=>this.layout());this.resize.observe(this.network);this.connections.forEach(({card})=>this.resize.observe(card));
      this.observer=new IntersectionObserver(()=>this.updateVisibility(),{threshold:.05});this.observer.observe(this);
      on(window,'scroll',()=>this.updateVisibility(),{passive:true});
      on(document,'visibilitychange',()=>this.sync());on(this.reduced,'change',()=>this.sync());on(this.mobile,'change',()=>this.layout());
      this.elapsed=0;this.step=this.step.bind(this);this.setCharge(0);this.layout();this.updateVisibility();
    }
    icon(card,play=false) {
      const icon=card.querySelector('[data-engine-icon]');const player=icon?.playerInstance;
      if(!player?.isReady)return;
      player.loop=false;player.pause();icon.parentElement.classList.add('is-ready');
      if(play&&!this.reduced.matches&&!document.hidden)player.playFromBeginning();else player.goToLastFrame();
    }
    layout() {
      const box=this.network.getBoundingClientRect();const hub=this.hub.getBoundingClientRect();
      this.wires.setAttribute('viewBox',`0 0 ${box.width} ${box.height}`);
      this.connections.forEach(connection=>{
        const rect=connection.card.getBoundingClientRect();
        const y=rect.top+rect.height/2-box.top;
        let d;
        if(this.mobile.matches) {
          const x=rect.left-box.left;const endX=hub.left+hub.width/2-box.left;const endY=hub.top+hub.height/2-box.top;
          d=`M${x},${y}H${endX+10}Q${endX},${y} ${endX},${y-10}V${endY}`;
        } else {
          const left=connection.card.dataset.side==='left';const x=(left?rect.right:rect.left)-box.left;
          const cy=hub.top+hub.height/2-box.top;const radius=hub.width*117/260;
          const dy=Math.max(-radius*.8,Math.min(radius*.8,(y-cy)*.3));
          const endX=hub.left+hub.width/2-box.left+(left?-1:1)*Math.sqrt(radius*radius-dy*dy);const endY=cy+dy;const middle=(x+endX)/2;
          d=`M${x},${y}C${middle},${y} ${middle},${endY} ${endX},${endY}`;
        }
        connection.line.setAttribute('d',d);connection.trail.setAttribute('d',d);connection.length=connection.line.getTotalLength();
      });
    }
    updateVisibility() {
      const rect=this.getBoundingClientRect();
      const visible=rect.bottom>0 && rect.top<window.innerHeight;
      if(visible!==this.visible) {this.visible=visible;this.sync();}
    }
    sync() {
      const moving = this.visible && !document.hidden && !this.reduced.matches;
      this.classList.toggle('is-motion-active',Boolean(moving));
      if (!moving) {
        cancelAnimationFrame(this.frame); this.frame=null; this.lastTime=null;
        this.corePulse?.cancel(); this.hub.classList.remove('is-completion-pulse');
        this.connections.forEach(({dot,trail,card})=>{dot.style.opacity=trail.style.opacity='0';this.icon(card);});
        if(this.reduced.matches)this.setCharge(this.connections.length*2);
      } else if(!this.frame)this.frame=requestAnimationFrame(this.step);
    }
    step(time) {
      if (this.lastTime != null) this.elapsed += Math.min(80, time - this.lastTime);
      this.lastTime = time;
      if (this.chargeCompletedAt != null && this.elapsed - this.chargeCompletedAt >= 10000) this.restartCycle();
      this.connections.forEach(connection => {
        const { delay, line, trail, gradient, dot, length } = connection;
        const travel = this.elapsed - delay;
        const age = travel % 6200;
        const cycle = Math.floor(travel / 6200);
        if (age >= 2600 && cycle >= 0 && connection.arrivalCycle !== cycle) {
          connection.arrivalCycle = cycle;
          this.pulseCore();
        }
        const active = age >= 0 && age < 2600 && length > 0;
        if (!active) { trail.style.opacity = dot.style.opacity = '0'; return; }
        const progress = age / 2600;
        const tailStart = Math.max(0, progress - .18);
        const alpha = Math.min(age / 250, (2600 - age) / 250, 1);
        const point = line.getPointAtLength(progress * length);
        const tailPoint = line.getPointAtLength(tailStart * length);
        gradient.setAttribute('x1', tailPoint.x); gradient.setAttribute('y1', tailPoint.y);
        gradient.setAttribute('x2', point.x); gradient.setAttribute('y2', point.y);
        dot.setAttribute('cx', point.x); dot.setAttribute('cy', point.y); dot.style.opacity = String(alpha * .8);
        trail.style.strokeDasharray = `${Math.min(.18, progress)} 1`;
        trail.style.strokeDashoffset = String(-tailStart);
        trail.style.opacity = String(alpha * .5);
      });
      if (this.chargeCompletedAt != null && this.elapsed >= this.chargeCompletedAt && !this.completionPlayed) this.pulseCompletion();
      this.frame = requestAnimationFrame(this.step);
    }
    pulseCore() {
      if (!this.art || this.reduced.matches) return;
      if (this.chargeLevel >= this.connections.length * 2) return;
      this.corePulse?.cancel();
      this.hub.dataset.arrivals = String((Number(this.hub.dataset.arrivals) || 0) + 1);
      this.setCharge(this.chargeLevel + 1);
      this.corePulse = this.art.animate([
        { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 #7cffcb00)' },
        { transform: 'scale(1.13)', filter: 'drop-shadow(0 0 9px #7cffcb60)', offset: .28 },
        { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 #7cffcb00)' }
      ], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    pulseCompletion() {
      if (this.reduced.matches || !this.art || this.completionPlayed) return;
      this.completionPlayed = true;
      this.hub.dataset.completionPulses = String((Number(this.hub.dataset.completionPulses) || 0) + 1);
      this.hub.classList.add('is-completion-pulse');
      this.corePulse?.cancel();
      this.corePulse = this.art.animate([
        { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 #7cffcb00)' },
        { transform: 'scale(1.27)', filter: 'drop-shadow(0 0 16px #7cffcb99)', offset: .22 },
        { transform: 'scale(.96)', filter: 'drop-shadow(0 0 5px #7cffcb40)', offset: .4 },
        { transform: 'scale(1.13)', filter: 'drop-shadow(0 0 11px #7cffcb75)', offset: .57 },
        { transform: 'scale(1)', filter: 'drop-shadow(0 0 4px #7cffcb30)', offset: .8 },
        { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 #7cffcb00)' }
      ], { duration: 1450, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    setCharge(level) {
      const total = this.connections.length * 2;
      const previous = this.chargeLevel;
      this.chargeLevel = Math.min(total, Math.max(0, level));
      this.hub.dataset.charge = String(this.chargeLevel);
      this.hub.dataset.chargeTotal = String(total);
      this.hub.dataset.charged = String(total > 0 && this.chargeLevel === total);
      this.chargeRing.style.strokeDashoffset = String(total ? 1 - this.chargeLevel / total : 1);
      // SVG units: the soft fill is 125% of the 699-unit isotype height.
      this.hub.style.setProperty('--engine-fill-shift', `${total ? 873.75 * (1 - this.chargeLevel / total) : 873.75}px`);
      // Allow 500 ms for the last fill/arc, then hold the completed state for 10 s.
      if (this.chargeLevel === total && previous < total) this.chargeCompletedAt = this.elapsed + 500;
      else if (this.chargeLevel < total) {
        this.chargeCompletedAt = null;
        this.completionPlayed = false;
        this.hub.classList.remove('is-completion-pulse');
      }
    }
    restartCycle() {
      this.corePulse?.cancel();
      this.elapsed = 0;
      this.lastTime = null;
      this.connections.forEach(connection => {
        connection.arrivalCycle = -1;
        connection.trail.style.opacity = connection.dot.style.opacity = '0';
      });
      this.setCharge(0);
      this.hub.dataset.cycle = String((Number(this.hub.dataset.cycle) || 0) + 1);
    }
    disconnectedCallback() {this.abort?.abort();this.abort=null;this.resize?.disconnect();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.corePulse?.cancel();this.frame=null;this.lastTime=null;this.connections?.forEach(({card})=>this.icon(card));this.wires?.replaceChildren();}
  }
  customElements.define('bc-service-engine',ServiceEngine);
})();
